<script setup lang="ts">
import { RouterView } from 'vue-router';
import { useThemeStore, type Theme } from 'shared/themes/stores/themeStore'
import { useFavicon, usePreferredDark, useTitle } from '@vueuse/core'
import { computed } from 'vue';
import { useDarkMode } from 'shared/themes/composables/darkMode';

const SILogDarkFavicon = '/silog-symbol.png'
const SILogLightFavicon = '/silog-symbol-vit.png'
const TiYardFavicon = '/TiYard_favicon.png'

const theme = useThemeStore();

const title = computed(() => theme.currentTheme === 'SILog' ? 'SILog Cloud' : 'TiYard Cloud');
useTitle(title);

const prefersDark = usePreferredDark()

const silogFaviconPath = computed(() =>
  prefersDark.value ? SILogLightFavicon : SILogDarkFavicon
)

const faviconPath = computed(() => {
  return theme.currentTheme === 'SILog' ? silogFaviconPath.value : TiYardFavicon
})

useDarkMode();
useFavicon(faviconPath);
</script>

<template>
  <RouterView />
</template>


